import { httpClient } from '@/services/http/httpClient'

type Params = {
  file: File
}

export async function importCsv({ file }: Params) {
  const payload = new FormData()
  payload.append('file', file)

  await httpClient.post('/users/import/csv', payload, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
